"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const processSteps = [{
  title: "Schedule Inspection",
  description: "Easily book your inspection online or by phone. We offer same-day scheduling to fit your timeline."
}, {
  title: "Property Inspection",
  description: "Our experienced inspector conducts a thorough, unbiased evaluation of the property's condition."
}, {
  title: "Detailed Report",
  description: "Receive a comprehensive, easy-to-read report with photos delivered within 24 hours."
}, {
  title: "Review Findings",
  description: "We walk you through the results, answering any questions to ensure you have complete peace of mind."
}];
export default function OurInspectionProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-inspection-process" className="py-24 lg:py-32 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground mb-6 uppercase tracking-tight">
            Our Inspection <span className="text-primary">Process</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            A clear, straightforward approach to giving you complete peace of mind about your property.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden lg:block absolute top-[48px] left-[12.5%] right-[12.5%] border-t-2 border-dashed border-border z-0" />

          {}
          <div className="block lg:hidden absolute left-[30px] top-[40px] bottom-[40px] border-l-2 border-dashed border-border z-0" />

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
            {processSteps.map((step, i) => <div key={i} data-index={i} className="relative pl-20 lg:pl-0 lg:text-center group">
                {}
                <div className="absolute top-0 left-0 lg:left-1/2 lg:-translate-x-1/2 text-6xl lg:text-8xl font-black text-transparent [-webkit-text-stroke:2px_var(--color-primary)] opacity-30 group-hover:opacity-60 transition-opacity duration-300 select-none z-10 leading-none bg-background lg:px-6">
                  0{i + 1}
                </div>

                {}
                <div className="relative z-20 pt-3 lg:pt-20">
                  <h3 className="text-xl font-bold text-foreground mb-3">
                    {step.title}
                  </h3>
                  <p className="text-base text-muted-foreground leading-relaxed max-w-[280px] lg:mx-auto">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}